export const RADIO_GROUP_TYPES = {
  PRIMARY_NEXT: 'primary-next',
  VERTICAL: 'vertical',
  TAB_LIKE: 'tab-like',
  BLOCKS: 'blocks',
  LIST: 'list'
}

export const RADIO_GROUP_SIZES = {
  LARGE: 'large',
  DEFAULT: 'default',
  SMALL: 'small',
  XS: 'xs',
  MD: 'md'
}

export const MULTIPLE_RADIO_GROUP_TYPES = {
  HORIZONTAL: 'horizontal'
}
